import "../tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function (Component, Event) {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "link-editor",

    /**
     * @description The template file to use to load and render the component.
     * @see link-editor-template.hbs
     */
    templateId: "link-editor-template",

    /**
     * @name update
     * @description
     * Manipulate the context of this element so that it always perpetuates in
     *  the correct state.
     * @param {HTMLElement} element
     * @param {object} context
     */
    update: function (element, context) {
      var $element = jQuery(this.element);
      var tool = this;
      var input = $element.find("input");

      if (input.val() != context.text) {
        // Avoid moving the cursor if we're typing in the input
        input.val(context.text);
      }

      if (context.url) {
        $element.find(".preview").show();
        $element.find("button").hide();

        var $preview = $element.find(".preview .page-title");

        if (context.url.match(/sparkle:\/\//)) {
          // Update the text in the link preview only if it is stale
          if (context.url != tool.lastFetchedUrl) {
            var fetchUrl = context.url; // Store this variable in case it is changed before `resolveUrl` completes
            tool.lastFetchedUrl = fetchUrl;

            $preview.html("Loading…");
            Sparkle.PageBuilder.resolveUrl(fetchUrl).then(function (data) {
              $preview.html(data.label || fetchUrl);
            });
          }
        } else if (context.url.startsWith("#")) {
          $preview.html("Anchor");
        } else {
          $preview.html("External URL");
        }
      } else {
        $element.find(".preview").hide();
        $element.find("button").show();
      }

      this.component.render();
    },

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component, and also add in
     *  any extra functionality to manage the slideshow
     * @param {HTMLElement} component
     */
    bind: function (component) {
      var $element = jQuery(this.element);

      $element.on(
        "input",
        function (event) {
          var value = this.component.context;
          this.component.save({
            url: value.url,
            text: jQuery(event.target).val(),
            behaviour: value.behaviour,
            style: value.style,
          });
          this.update(this.element, this.component.context);
        }.bind(this),
      );

      $element.on(
        "click",
        ".remove",
        function (event) {
          var value = this.component.context;
          this.component.save({ url: null, text: value.text, style: value.style });
          this.update(this.element, this.component.context);

          event.preventDefault();
        }.bind(this),
      );

      $element.on(
        "click",
        ".edit",
        function (event) {
          event.preventDefault();

          var context = this.component.context;
          var initialValue = {
            title: context.text,
            url: context.url,
            style: context.style,
            behaviour: context.behaviour,
            target: context.target,
          };

          var dialog = new Sparkle.PageBuilder.LinkDialog(
            initialValue,
            function (value) {
              this.component.save({
                url: value.url,
                text: value.title,
                style: value.style,
                behaviour: value.behaviour,
                target: value.target,
              });
              this.update(this.element, this.component.context);
            }.bind(this),
          );
        }.bind(this),
      );

      this.update(this.element, this.component.context);
    },

    /**
     * @name bind
     * @description
     * Unbind the different event listeners to the component added during the
     *  initial bind step.
     * @param {HTMLElement} element
     */
    unbind: function (element) {
      var $element = jQuery(this.element);
      $element.off("click");
      $element.off("keyup");
    },
  });
})(Sparkle.PageBuilder.Component, Sparkle.PageBuilder.Helpers.Event);
